import { createRouter, createWebHistory, Router } from 'vue-router';
import { routes } from '@/router/routes/routes';
import { useEnvStore } from '@/store/env.store';
import { DASHBOARD_META_TITLES } from '@/models/common/meta-titles.model';

export const createAppRouter = (): Router => {
  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  router.beforeEach((to, _from, next) => {
    const selectedWhitelabelSlug = sessionStorage.getItem('selectedWhitelabelSlug');

    if (!to.query.brand && selectedWhitelabelSlug) {
      return next({ ...to, query: { ...to.query, brand: selectedWhitelabelSlug } });
    }

    next();
  });

  router.afterEach((to, _from, failure) => {
    if (failure) {
      return;
    }

    useEnvStore().setMetaTitle(to.meta.title ?? DASHBOARD_META_TITLES.BACKOFFICE);
  });

  return router;
};
